import { useCallback, useEffect, useState } from "react";

export interface ContextMenuState {
  visible: boolean;
  x: number;
  y: number;
  row: Record<string, unknown>;
  cellValue?: string | number;
  columnKey?: string;
  columnName?: string;
}

export function useChartDataTableContextMenu() {
  const [contextMenu, setContextMenu] = useState<ContextMenuState | null>(null);

  const handleContextMenuClose = useCallback(() => {
    setContextMenu(null);
  }, []);

  useEffect(() => {
    const handleClickOutside = () => {
      if (contextMenu) {
        handleContextMenuClose();
      }
    };

    if (contextMenu) {
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }
  }, [contextMenu, handleContextMenuClose]);

  return {
    contextMenu,
    setContextMenu,
    handleContextMenuClose
  };
}
